/** Deterministic geometry shared by the browser and trusted server admission. */
export const UPSCALE_MAX_EDGE = 8192;
export const UPSCALE_MAX_INPUT_EDGE = 32768;
export const UPSCALE_MAX_PIXELS = 67108864;
const PROFILES = {
  small: { maxSeconds: 90, reserveMicroUsd: 100000 },
  medium: { maxSeconds: 240, reserveMicroUsd: 150000 },
  large: { maxSeconds: 600, reserveMicroUsd: 240000 },
};
export function planUpscale({ width, height }, scale) {
  if (![width, height].every(value => Number.isSafeInteger(value) && value > 0)
      || Math.max(width, height) > UPSCALE_MAX_INPUT_EDGE || width * height > UPSCALE_MAX_PIXELS
      || ![2, 4].includes(scale)) throw new RangeError('Invalid upscale geometry.');
  const longest = Math.max(width, height);
  const quality2x = scale === 2 && longest <= 2048 && width * height <= 2000000;
  const nativeScale = quality2x || Math.min(scale, UPSCALE_MAX_EDGE / longest) > 2 ? 4 : 2;
  const reduce = !quality2x && longest * nativeScale > UPSCALE_MAX_EDGE;
  // Integer numerator division avoids a floating ratio rounding an exact long edge down.
  const workingWidth = reduce ? Math.max(1, Math.floor(width * UPSCALE_MAX_EDGE / (longest * nativeScale))) : width;
  const workingHeight = reduce ? Math.max(1, Math.floor(height * UPSCALE_MAX_EDGE / (longest * nativeScale))) : height;
  const outputWidth = workingWidth * (quality2x ? 2 : nativeScale);
  const outputHeight = workingHeight * (quality2x ? 2 : nativeScale);
  const trunkPixels = nativeScale === 2 ? Math.ceil(workingWidth / 2) * Math.ceil(workingHeight / 2) : workingWidth * workingHeight;
  const profile = trunkPixels <= 500000 ? 'small' : trunkPixels <= 2000000 ? 'medium' : 'large';
  return { workingWidth, workingHeight, outputWidth, outputHeight, nativeScale, profile,
    ...PROFILES[profile], adjusted: outputWidth !== width * scale || outputHeight !== height * scale };
}
